import { pageDto } from "./pagedto";
import { User } from "./user";

export class UserResponse {

    listUser: User[] = [];

    pageDto: pageDto = new pageDto({});

}
